/* ------------------------------------------------------------------
   zetse — puts the back arrow into the product page header.

   The header section only renders one on collection, cart and content
   pages; rather than reopen that section, the arrow is added here, in
   the same markup and with the same behaviour: real history when the
   customer came from somewhere on the site, and a sensible destination
   when they landed here cold from a shared link.

   Loaded straight after the header in the layout, so it runs the
   moment the header exists rather than waiting for the whole page.
------------------------------------------------------------------- */
(function () {
  'use strict';

  if (!/(^|\s)tpl-product(\s|$)/.test(document.body.className)) return;

  var row = document.querySelector('.site-header__row');
  if (!row || row.querySelector('.site-header__back')) return;

  var back = document.createElement('a');
  back.className = 'site-header__back';
  back.setAttribute('aria-label', 'Go back');
  back.setAttribute('data-header-back', '');
  back.href = '/collections';
  back.innerHTML = '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg>';
  row.insertBefore(back, row.firstChild);

  back.addEventListener('click', function (e) {
    if (window.history.length > 1 && document.referrer.indexOf(window.location.origin) === 0) {
      e.preventDefault();
      window.history.back();
    }
  });
})();
